import { render } from "./ListBanksTable.vue?vue&type=template&id=22b7c066&scoped=true"
import script from "./ListBanksTable.vue?vue&type=script&lang=js"
export * from "./ListBanksTable.vue?vue&type=script&lang=js"

import "./ListBanksTable.vue?vue&type=style&index=0&id=22b7c066&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b7c066"]])

export default __exports__